/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState, useRef, useEffect, useMemo } from "react";

import moment from "moment-timezone";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftComponents/SoftBox";
//Backend access
import { getCameraHistory } from 'services/api/bks';
import PropTypes from "prop-types";
import CameraSelects from "components/Charts/Selectors/Camera";
import { Chart as Chartjs, registerables } from 'chart.js';
import zoomPlugin from "chartjs-plugin-zoom";
import CameraFeedChart from "components/Charts/CameraFeedChart";

Chartjs.register(...registerables);
Chartjs.register(zoomPlugin);

function CameraFeed({ device, deviceLayout, directionTrigger }) {

  const [endTime, setEndTime] = useState(moment());
  const [startTime, setStartTime] = useState(deviceLayout == 'mobile' ? moment().subtract(3, 'hour') : moment().subtract(1, 'day'));
  const [chartData, setChartData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const setLimits = true;

  useEffect(() => {
    async function getHistory() {
      // console.log(startTime.unix(), endTime.unix());
      var data = await getCameraHistory(device.uuid, startTime.unix(), endTime.unix(), true);
      // console.log(data);
      setChartData(data);
      setIsLoading(false);
    }
    getHistory();
  }, [startTime, endTime]);

  return (
    <SoftBox>
      <CameraSelects {...{ startTime, setStartTime, endTime, setEndTime, setLimits }} />
      <CameraFeedChart {...{ device, startTime, endTime, setStartTime, setEndTime, chartData, isLoading, setIsLoading, directionTrigger }} />
    </SoftBox>
  );
}

// Typechecking props for the CameraFeed
CameraFeed.propTypes = {
  device: PropTypes.object,
  deviceLayout: PropTypes.string,
  directionTrigger: PropTypes.object
};


export default CameraFeed;
